import { createAction } from 'utils/reduxHelpers';

import * as t from './actionTypes';

export type ApiKeyAction = {
  type: string;
  payload?: boolean;
  errors?: string;
  errorType?: string;
};

export const fetchApiKeysRequest = createAction(t.FETCH_API_KEYS_REQUEST);
export const fetchApiKeysResponse = createAction(t.FETCH_API_KEYS_RESPONSE);

export const fetchApiKeyTypesRequest = createAction(t.FETCH_API_KEY_TYPES_REQUEST);
export const fetchApiKeyTypesResponse = createAction(t.FETCH_API_KEY_TYPES_RESPONSE);

export const setApiKeyErrors = createAction(t.SET_API_KEY_ERRORS);
